class CustomCarousel extends window.HTMLElement {
    constructor() {
        super();
        this.selectors = {
            loop: "data-loop",
            scrollCount: "[data-scroll-num]",
            dragFree: "data-drag-free",
            align: "data-align",
            controls: "data-controls",
            carouselContainer: ".carousel-container",
            progressBar: ".progress-bar",
            currentSlide: ".current-slide",
            totalSlides: ".total-slides"
        };

        this.observer = null;
    }

    connectedCallback() {
        const loop = this.hasAttribute(this.selectors.loop);
        const scrollCount = this.getAttribute(this.selectors.scrollCount) ?? 1;
        const dragFree = this.hasAttribute(this.selectors.dragFree);
        const controls = this.hasAttribute(this.selectors.controls);
        const align = this.getAttribute(this.selectors.align) ?? 'start';

        const carouselContainer = this.querySelector(this.selectors.carouselContainer);
        
        this.embla = EmblaCarousel(carouselContainer, {
            loop: loop,
            align: align,
            dragFree: dragFree,
            skipSnaps: true,
            slidesToScroll: parseInt(scrollCount),
        });

        if (controls) {
            this.setupControls();
        }

        this.embla.on('select', () => {
            this.updateProgressBar();
        });

        this.embla.on('scroll', () => {
            this.updateProgressBar();
        });

        this.setupProgressBar();
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if (this.embla) {
            this.embla.destroy();
            this.embla = null;
        }
    }

    setupControls() {
        const prevBtnNodes = Array.from(this.querySelectorAll(".embla__button--prev"));
        const nextBtnNodes = Array.from(this.querySelectorAll(".embla__button--next"));

        prevBtnNodes.forEach((prevBtnNode, index) => {
            const nextBtnNode = nextBtnNodes[index];
            if (nextBtnNode) {
                const removePrevNextBtnsClickHandlers = this.addPrevNextBtnsClickHandlers(
                    this.embla,
                    prevBtnNode,
                    nextBtnNode
                );
                this.embla.on('destroy', removePrevNextBtnsClickHandlers);
            }
        });
    }

    setupProgressBar() {
        this.updateProgressBar();
    }

    // updateProgressBar() {
    //     const progressBars = this.querySelectorAll(this.selectors.progressBar);
    //     const currentSlideIndicator = this.querySelector(this.selectors.currentSlide);
    //     const totalSlidesIndicator = this.querySelector(this.selectors.totalSlides);
    //     if (progressBars.length === 0) return;
    //     const totalSlides = this.embla.slideNodes().length;
    //     // const barWidth = (100 / totalSlides)
    //     // progressBars[0].style.width = `${barWidth}%`
    //     totalSlidesIndicator.textContent = totalSlides
    
    //     setTimeout(() => {
    //         const totalSlides = this.embla.slideNodes().length;
    //         const scrollProgress = this.embla.scrollProgress();

    //         const fullyVisibleSlides = this.embla
    //             .slidesInView(true)
    //             .length - 1;

    //         const initialProgress = (fullyVisibleSlides / totalSlides) * 100;
    //         const currentProgress = scrollProgress * (100 - initialProgress) + initialProgress;

    //         progressBars.forEach(progressBar => {
    //             progressBar.style.left = `${currentProgress}%`
    //             progressBar.style.transform = `translateX(-${currentProgress}%)`
    //             currentSlideIndicator.textContent = this.embla.selectedScrollSnap() + 1
    //         });
    //     }, 100);
    // }      
    
    updateProgressBar() {
        const progressBars = this.querySelectorAll(this.selectors.progressBar);
        const currentSlideIndicator = this.querySelector(this.selectors.currentSlide);
        const totalSlidesIndicator = this.querySelector(this.selectors.totalSlides);
        if (progressBars.length === 0) return;
        
        
        
        const totalSlides = this.embla.slideNodes().length;
        totalSlidesIndicator.textContent = totalSlides;
        
        const barWidth = (100 / totalSlides)
        progressBars[0].style.width = `${barWidth}%`
    
        const scrollProgress = this.embla.scrollProgress();
        const currentProgress = scrollProgress * 100;

        progressBars.forEach(progressBar => {
            progressBar.style.transform = `translateX(-${currentProgress}%)`;
            progressBar.style.left = `${currentProgress}%`;
        });

        // Update the current slide indicator based on current scroll snap
        currentSlideIndicator.textContent = this.embla.selectedScrollSnap() + 1;
    }
    

    addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
            else prevBtn.setAttribute('disabled', 'disabled');

            if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
            else nextBtn.setAttribute('disabled', 'disabled');
        };

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState);

        return () => {
            prevBtn.removeAttribute('disabled');
            nextBtn.removeAttribute('disabled');
        };
    }

    addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
        const scrollPrev = () => {
            emblaApi.scrollPrev();
        };
        const scrollNext = () => {
            emblaApi.scrollNext();
        };
        prevBtn.addEventListener('click', scrollPrev, false);
        nextBtn.addEventListener('click', scrollNext, false);

        const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        );

        return () => {
            removeTogglePrevNextBtnsActive();
            prevBtn.removeEventListener('click', scrollPrev, false);
            nextBtn.removeEventListener('click', scrollNext, false);
        };
    }
}

window.customElements.define("custom-carousel", CustomCarousel);